/*
 * Diwali Crackers - festive fireworks on successful add-to-cart
 * ------------------------------------------------------------
 * Fires on ANY successful POST to /cart/add (fetch or XHR), so it covers the
 * Shella theme cart, FBT section, collection quick-add, Marmeto filter forms
 * and most third-party apps without touching their code.
 *
 * Config comes from window.DiwaliCrackersConfig (rendered by snippets/diwali-crackers.liquid).
 * Manual trigger for testing:  window.DiwaliCrackers.play()   or add ?diwali_test=1 to any URL.
 */
(function () {
  'use strict';

  if (window.DiwaliCrackers) return; // guard against double include

  var cfg = Object.assign(
    {
      enabled: true,
      startDate: '',
      endDate: '',
      intensity: 'medium', // light | medium | grand
      dim: true,
      addedLabel: 'Added to your cart',
      message: 'Shubh Deepawali',
      fontUrl: '',
      mobile: true
    },
    window.DiwaliCrackersConfig || {}
  );

  /* ---------- Guards: on/off, date window, mobile ---------- */

  function parseDay(str, endOfDay) {
    if (!str || !/^\d{4}-\d{2}-\d{2}$/.test(String(str).trim())) return null;
    var p = String(str).trim().split('-');
    return endOfDay
      ? new Date(+p[0], +p[1] - 1, +p[2], 23, 59, 59)
      : new Date(+p[0], +p[1] - 1, +p[2], 0, 0, 0);
  }

  function isActive() {
    if (!cfg.enabled) return false;
    var now = new Date();
    var start = parseDay(cfg.startDate, false);
    var end = parseDay(cfg.endDate, true);
    if (start && now < start) return false;
    if (end && now > end) return false;
    if (!cfg.mobile && window.matchMedia('(max-width: 767px)').matches) return false;
    return true;
  }

  // Debug: add ?diwali_debug=1 once; it stays on for the browser tab and logs to the console.
  var DEBUG = false;
  try {
    if (/[?&]diwali_debug=1\b/.test(location.search)) sessionStorage.setItem('dc_debug', '1');
    DEBUG = sessionStorage.getItem('dc_debug') === '1';
  } catch (e) {}
  // On-screen panel so phones (no console) can screenshot what happened.
  var debugBox = null;
  function debugPanel(line) {
    if (!document.body) return;
    if (!debugBox) {
      debugBox = document.createElement('div');
      debugBox.setAttribute('style', 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;max-height:38vh;overflow:auto;' +
        'background:rgba(20,6,10,.92);color:#ffe9a8;font:12px/1.45 monospace;padding:8px 10px;border-radius:8px;' +
        'border:1px solid #c9922e;white-space:pre-wrap;word-break:break-word');
      var close = document.createElement('button');
      close.textContent = 'close debug';
      close.setAttribute('style', 'float:right;background:#c9922e;color:#2b1208;border:0;border-radius:4px;font:11px monospace;padding:2px 6px;margin:0 0 4px 6px');
      close.onclick = function () {
        try { sessionStorage.removeItem('dc_debug'); } catch (e) {}
        debugBox.remove(); debugBox = null; DEBUG = false;
      };
      debugBox.appendChild(close);
      document.body.appendChild(debugBox);
    }
    var row = document.createElement('div');
    row.textContent = new Date().toLocaleTimeString() + '  ' + line;
    debugBox.appendChild(row);
    debugBox.scrollTop = debugBox.scrollHeight;
  }
  function log() {
    if (!DEBUG) return;
    var args = [].slice.call(arguments);
    if (window.console) console.log.apply(console, ['[DiwaliCrackers]'].concat(args));
    var text = args.map(function (a) {
      if (a && typeof a === 'object') { try { return JSON.stringify(a); } catch (e) { return String(a); } }
      return String(a);
    }).join(' ');
    if (document.body) debugPanel(text);
    else document.addEventListener('DOMContentLoaded', function () { debugPanel(text); });
  }
  function whyInactive() {
    if (!cfg.enabled) return 'disabled in theme settings';
    var now = new Date(), start = parseDay(cfg.startDate, false), end = parseDay(cfg.endDate, true);
    if (start && now < start) return 'before start date ' + cfg.startDate + ' (device date: ' + now.toDateString() + ')';
    if (end && now > end) return 'after end date ' + cfg.endDate + ' (device date: ' + now.toDateString() + ')';
    if (!cfg.mobile && window.matchMedia('(max-width: 767px)').matches) return 'mobile is turned off in settings';
    return '';
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Palette ---------- */

  var COLORS = ['#FF9933', '#FFC233', '#FF3D8B', '#2EE59D', '#A66CFF', '#FF4D4D', '#4DD9FF'];
  var GOLD = ['#FFD36B', '#FFE9A8', '#FFB338', '#FFF6D8'];

  function pick(arr) { return arr[(Math.random() * arr.length) | 0]; }
  function rand(a, b) { return a + Math.random() * (b - a); }

  /* ---------- Stage (canvas + backdrop + greeting) ---------- */

  var stage = null; // {canvas, ctx, backdrop, toast, w, h, dpr}
  var particles = [];
  var rockets = [];
  var fountains = [];
  var flashes = [];
  var running = false;
  var lastT = 0;
  var stopAt = 0;
  var MAX_PARTICLES = 900;

  function injectStyles() {
    if (document.getElementById('dc-styles')) return;
    var css =
      '.dc-canvas{position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483600}' +
      '.dc-backdrop{position:fixed;inset:0;pointer-events:none;z-index:2147483599;opacity:0;' +
      'background:radial-gradient(ellipse at 50% 35%,rgba(28,8,36,.58),rgba(8,2,14,.72));transition:opacity .45s ease}' +
      '.dc-backdrop.is-on{opacity:1}' +
      (cfg.fontUrl ? "@font-face{font-family:'DC Display';src:url('" + cfg.fontUrl + "') format('truetype');font-display:swap}" : '') +
      '.dc-toast{position:fixed;left:50%;top:14vh;z-index:2147483601;pointer-events:none;' +
      'transform:translate(-50%,-12px) scale(.96);opacity:0;transition:opacity .4s ease,transform .5s cubic-bezier(.2,.9,.3,1.3);' +
      'display:flex;align-items:center;gap:14px;padding:12px 30px 12px 20px;border-radius:999px;max-width:calc(100vw - 32px);white-space:nowrap;' +
      'background:linear-gradient(135deg,#3b0d2e,#5a1a1a);color:#FFE9A8;border:1px solid rgba(255,194,51,.55);' +
      'box-shadow:0 10px 40px rgba(255,153,51,.35),inset 0 0 18px rgba(255,194,51,.12);' +
      'font-family:inherit;text-align:left}' +
      '.dc-toast.is-on{opacity:1;transform:translate(-50%,0) scale(1)}' +
      '.dc-toast__diya{font-size:30px;line-height:1;filter:drop-shadow(0 0 8px rgba(255,170,40,.9))}' +
      '.dc-toast__lines{display:flex;flex-direction:column;gap:2px}' +
      '.dc-toast__added{font-size:12px;font-weight:700;letter-spacing:1.6px;text-transform:uppercase;color:#FFC233;line-height:1.2}' +
      '.dc-toast__greet{font-family:"DC Display",Georgia,"Times New Roman",serif;font-size:22px;line-height:1.15;color:#FFE9A8}' +
      '@media (max-width:767px){.dc-toast{top:10vh;padding:10px 22px 10px 16px;gap:10px}.dc-toast__diya{font-size:24px}' +
      '.dc-toast__added{font-size:10.5px}.dc-toast__greet{font-size:18px}}';
    var s = document.createElement('style');
    s.id = 'dc-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function ensureStage() {
    if (stage) return stage;
    injectStyles();
    var canvas = document.createElement('canvas');
    canvas.className = 'dc-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    var backdrop = document.createElement('div');
    backdrop.className = 'dc-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    document.body.appendChild(canvas);
    stage = { canvas: canvas, ctx: canvas.getContext('2d'), backdrop: backdrop, toast: null, w: 0, h: 0, dpr: 1 };
    resize();
    window.addEventListener('resize', resize);
    return stage;
  }

  function resize() {
    if (!stage) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    stage.dpr = dpr;
    stage.w = window.innerWidth;
    stage.h = window.innerHeight;
    stage.canvas.width = Math.round(stage.w * dpr);
    stage.canvas.height = Math.round(stage.h * dpr);
    stage.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function teardown() {
    if (!stage) return;
    var s = stage;
    stage = null;
    window.removeEventListener('resize', resize);
    s.backdrop.classList.remove('is-on');
    setTimeout(function () {
      s.canvas.remove();
      s.backdrop.remove();
    }, 500);
  }

  var toastTimer = null;
  function showToast() {
    var top = (cfg.addedLabel || '').trim();   // "Added to your cart"  (upar)
    var bottom = (cfg.message || '').trim();   // "Shubh Deepawali"     (niche)
    if (!top && !bottom) return;
    injectStyles();
    var el = document.querySelector('.dc-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'dc-toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="dc-toast__diya" aria-hidden="true">\uD83E\uDE94</span>' +
        '<span class="dc-toast__lines"><span class="dc-toast__added"></span><span class="dc-toast__greet"></span></span>';
      document.body.appendChild(el);
    }
    var a = el.querySelector('.dc-toast__added'), g = el.querySelector('.dc-toast__greet');
    a.textContent = top; a.style.display = top ? '' : 'none';
    g.textContent = bottom; g.style.display = bottom ? '' : 'none';
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { if (!el.classList.contains('is-on')) el.remove(); }, 500);
    }, 2600);
  }

  /* ---------- Effects ---------- */

  function spark(x, y, vx, vy, o) {
    if (particles.length >= MAX_PARTICLES) return;
    particles.push({
      x: x, y: y, px: x, py: y, vx: vx, vy: vy,
      life: 1,
      decay: o.decay || rand(0.012, 0.022),
      color: o.color,
      size: o.size || rand(1.4, 2.4),
      gravity: o.gravity == null ? 0.06 : o.gravity,
      drag: o.drag == null ? 0.985 : o.drag,
      twinkle: !!o.twinkle,
      crackle: !!o.crackle
    });
  }

  function flash(x, y, color, r) {
    flashes.push({ x: x, y: y, color: color, r: r, life: 1 });
  }

  function explode(r) {
    var scale = stage.w < 768 ? 0.7 : 1;
    var x = r.x, y = r.y, c = r.color, c2 = pick(COLORS), i, a, sp, n;
    flash(x, y, c, 70 * scale + 20);

    switch (r.type) {
      case 'ring':
        n = Math.round(56 * scale);
        sp = rand(3.6, 4.6) * scale + 0.6;
        for (i = 0; i < n; i++) {
          a = (i / n) * Math.PI * 2;
          spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, { color: i % 2 ? c : c2, decay: rand(0.013, 0.017), size: 2.2 });
        }
        // inner core
        for (i = 0; i < n / 2; i++) {
          a = Math.random() * Math.PI * 2;
          spark(x, y, Math.cos(a) * sp * 0.35, Math.sin(a) * sp * 0.35, { color: '#FFF6D8', decay: 0.03, size: 1.6 });
        }
        break;

      case 'willow':
        n = Math.round(90 * scale);
        for (i = 0; i < n; i++) {
          a = Math.random() * Math.PI * 2;
          sp = rand(1, 4.2) * scale + 0.4;
          spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, {
            color: pick(GOLD), decay: rand(0.006, 0.01), gravity: 0.045, drag: 0.975, size: rand(1.1, 1.8), twinkle: true
          });
        }
        break;

      case 'glitter':
        n = Math.round(80 * scale);
        for (i = 0; i < n; i++) {
          a = Math.random() * Math.PI * 2;
          sp = rand(1.5, 5.2) * scale + 0.4;
          spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, {
            color: Math.random() < 0.35 ? c : pick(GOLD), decay: rand(0.009, 0.015), size: rand(1.4, 2.2), twinkle: true, crackle: true
          });
        }
        break;

      default: // peony
        n = Math.round(84 * scale);
        for (i = 0; i < n; i++) {
          a = (i / n) * Math.PI * 2 + rand(-0.05, 0.05);
          sp = (rand(2.2, 5.6)) * scale + 0.5;
          spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, { color: Math.random() < 0.8 ? c : c2 });
        }
    }
  }

  function launchRocket(delay) {
    setTimeout(function () {
      if (!stage) return;
      var w = stage.w, h = stage.h;
      var x = rand(w * 0.14, w * 0.86);
      var targetY = rand(h * 0.14, h * 0.42);
      var dist = h - targetY;
      var vy = -Math.sqrt(2 * 0.2 * dist) * rand(0.98, 1.04); // reach ~targetY under gravity
      rockets.push({
        x: x, y: h + 6, vx: rand(-0.8, 0.8), vy: vy, targetY: targetY,
        color: pick(COLORS),
        type: pick(['peony', 'peony', 'ring', 'glitter', 'willow'])
      });
    }, delay);
  }

  function addFountain(x, durationMs) {
    fountains.push({ x: x, until: performance.now() + durationMs });
  }

  function sparklerAt(x, y) {
    for (var i = 0; i < 46; i++) {
      var a = Math.random() * Math.PI * 2;
      var sp = rand(1.5, 5.5);
      spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, {
        color: pick(GOLD), decay: rand(0.035, 0.06), gravity: 0.08, size: rand(1, 1.8)
      });
    }
    flash(x, y, '#FFE9A8', 34);
  }

  /* ---------- Loop ---------- */

  function frame(t) {
    if (!stage) { running = false; return; }
    var dt = Math.min((t - lastT) / 16.67, 3);
    lastT = t;
    var ctx = stage.ctx, w = stage.w, h = stage.h, i, p;

    // fade previous frame -> motion trails on a transparent canvas
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,' + Math.min(0.28 * dt, 0.6) + ')';
    ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'lighter';

    // fountains (anaar)
    for (i = fountains.length - 1; i >= 0; i--) {
      var f = fountains[i];
      if (t > f.until) { fountains.splice(i, 1); continue; }
      var count = Math.round(5 * dt);
      for (var k = 0; k < count; k++) {
        var ang = -Math.PI / 2 + rand(-0.32, 0.32);
        var spd = rand(5, 9.5) * (h < 700 ? 0.8 : 1);
        spark(f.x, h, Math.cos(ang) * spd, Math.sin(ang) * spd, {
          color: Math.random() < 0.15 ? '#FF9933' : pick(GOLD), decay: rand(0.014, 0.024), gravity: 0.16, drag: 0.99, size: rand(1.1, 2)
        });
      }
    }

    // rockets
    for (i = rockets.length - 1; i >= 0; i--) {
      var r = rockets[i];
      var ox = r.x, oy = r.y;
      r.vy += 0.2 * dt;
      r.x += r.vx * dt;
      r.y += r.vy * dt;
      ctx.strokeStyle = '#FFE9A8';
      ctx.lineWidth = 2.2;
      ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(ox, oy);
      ctx.lineTo(r.x, r.y);
      ctx.stroke();
      if (Math.random() < 0.7) {
        spark(r.x, r.y, rand(-0.4, 0.4), rand(0.5, 1.5), { color: pick(GOLD), decay: rand(0.04, 0.07), size: 1.2, gravity: 0.02 });
      }
      if (r.vy >= -1 || r.y <= r.targetY) {
        explode(r);
        rockets.splice(i, 1);
      }
    }

    // flashes
    for (i = flashes.length - 1; i >= 0; i--) {
      var fl = flashes[i];
      fl.life -= 0.08 * dt;
      if (fl.life <= 0) { flashes.splice(i, 1); continue; }
      var g = ctx.createRadialGradient(fl.x, fl.y, 0, fl.x, fl.y, fl.r);
      g.addColorStop(0, 'rgba(255,246,216,' + 0.55 * fl.life + ')');
      g.addColorStop(1, 'rgba(255,200,120,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(fl.x, fl.y, fl.r, 0, Math.PI * 2);
      ctx.fill();
    }

    // particles - grouped by colour/alpha/width and drawn in a few strokes (much lighter than one stroke each)
    var buckets = {}, alive = 0;
    for (i = 0; i < particles.length; i++) {
      p = particles[i];
      p.px = p.x; p.py = p.y;
      var drag = Math.pow(p.drag, dt);
      p.vx *= drag; p.vy *= drag;
      p.vy += p.gravity * dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.life -= p.decay * dt;

      if (p.life <= 0 || p.y > h + 20) {
        if (p.crackle && Math.random() < 0.35) {
          for (var c = 0; c < 3; c++) {
            spark(p.x, p.y, rand(-1.2, 1.2), rand(-1.2, 1.2), { color: '#FFF6D8', decay: 0.09, size: 1, gravity: 0 });
          }
        }
        continue;
      }
      particles[alive++] = p;

      var alpha = p.life;
      if (p.twinkle && Math.random() < 0.3) alpha *= 0.25;
      var lvl = Math.max(1, Math.ceil(alpha * 4));          // 4 alpha steps
      var wid = p.size < 1.7 ? 1.4 : 2.2;                   // 2 widths
      var key = p.color + '|' + lvl + '|' + wid;
      (buckets[key] || (buckets[key] = [])).push(p);
    }
    particles.length = alive;

    ctx.lineCap = 'round';
    for (var k in buckets) {
      var parts = k.split('|'), list = buckets[k];
      ctx.strokeStyle = parts[0];
      ctx.globalAlpha = +parts[1] / 4;
      ctx.lineWidth = +parts[2];
      ctx.beginPath();
      for (var q = 0; q < list.length; q++) {
        ctx.moveTo(list[q].px, list[q].py);
        ctx.lineTo(list[q].x, list[q].y);
      }
      ctx.stroke();
    }
    ctx.globalAlpha = 1;

    var idle = !particles.length && !rockets.length && !fountains.length && !flashes.length;
    if ((idle && t > stopAt) || t > stopAt + 4000) {
      running = false;
      particles.length = rockets.length = fountains.length = flashes.length = 0;
      teardown();
      return;
    }
    if (t > stopAt - 1200 && stage) stage.backdrop.classList.remove('is-on');
    requestAnimationFrame(frame);
  }

  /* ---------- Public play() ---------- */

  var lastPointer = null; // {x, y, t} - where the shopper last tapped, for the sparkler burst
  document.addEventListener('pointerdown', function (e) {
    lastPointer = { x: e.clientX, y: e.clientY, t: Date.now() };
  }, { capture: true, passive: true });

  var lastPlay = 0;

  function play(opts) {
    opts = opts || {};
    log('add-to-cart detected via', opts.via || 'manual');
    if (!opts.force && !isActive()) { log('not shown:', whyInactive()); return; }
    var now = Date.now();
    if (now - lastPlay < 900) return; // one add = one show (dedupe fetch + theme event)
    lastPlay = now;

    showToast();
    if (reduceMotion) { log('greeting only: phone has Reduce Motion / Remove animations turned on'); return; }
    log('playing fireworks, intensity:', cfg.intensity); // respect accessibility setting: greeting only, no animation

    ensureStage();
    var levels = { light: 3, medium: 5, grand: 8 };
    var n = levels[cfg.intensity] || 5;
    if (stage.w < 768) n = Math.max(2, Math.round(n * 0.7));

    if (cfg.dim) requestAnimationFrame(function () { stage && stage.backdrop.classList.add('is-on'); });

    if (lastPointer && now - lastPointer.t < 6000) sparklerAt(lastPointer.x, lastPointer.y);

    for (var i = 0; i < n; i++) launchRocket(i * rand(180, 300) + rand(0, 80));
    if (cfg.intensity !== 'light') {
      addFountain(stage.w * 0.06, 1500);
      addFountain(stage.w * 0.94, 1500);
    }
    if (cfg.intensity === 'grand') {
      setTimeout(function () { for (var j = 0; j < 3; j++) launchRocket(j * 120); }, n * 260 + 200);
    }

    stopAt = performance.now() + n * 280 + 2200;
    if (!running) {
      running = true;
      lastT = performance.now();
      requestAnimationFrame(frame);
    }
  }

  /* ---------- Detect successful add-to-cart ---------- */

  var ADD_RE = /\/cart\/add(\.js|\.json)?(\?|#|$)/;

  function isAddUrl(url) {
    try {
      return ADD_RE.test(new URL(String(url), location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  // fetch()
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = origFetch.apply(this, arguments);
      if (method === 'POST' && isAddUrl(url)) {
        p.then(function (res) { if (res && res.ok) play({ via: 'fetch' }); else log('fetch add failed, status', res && res.status); }).catch(function () {});
      }
      return p;
    };
  }

  // XMLHttpRequest (jQuery $.ajax, older apps)
  var XHR = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (XHR) {
    var origOpen = XHR.open;
    var origSend = XHR.send;
    XHR.open = function (method, url) {
      this.__dcAdd = String(method).toUpperCase() === 'POST' && isAddUrl(url);
      return origOpen.apply(this, arguments);
    };
    XHR.send = function () {
      if (this.__dcAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) play({ via: 'xhr' }); else log('xhr add failed, status', this.status);
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // Network-level backup: catches /cart/add requests made through a fetch/XHR
  // reference captured before this script loaded (apps, bundled theme code).
  // Deduped by play(), so a request seen by both the wrappers and this observer fires once.
  if (window.PerformanceObserver) {
    try {
      var seenAt = performance.now();
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.initiatorType !== 'fetch' && e.initiatorType !== 'xmlhttprequest') return;
          if (e.startTime < seenAt || !isAddUrl(e.name)) return;
          var st = e.responseStatus; // Chromium only; undefined elsewhere
          if (st && (st < 200 || st >= 300)) return;
          play({ via: 'network-observer' });
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }

  // Shella theme's own event (backup - deduped by play())
  document.addEventListener('theme:cart::added', function () { play({ via: 'theme event' }); });

  // Plain (non-AJAX) form posts to /cart/add reload the page - celebrate on the next page.
  var FLAG = 'dc_pending_celebration';
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !isAddUrl(form.action)) return;
    setTimeout(function () {
      if (!e.defaultPrevented) {
        try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (err) {}
        log('plain form post to /cart/add (page will reload), celebration queued for next page');
      }
    }, 0);
  });

  function onReady() {
    var pending = null;
    try {
      pending = sessionStorage.getItem(FLAG);
      sessionStorage.removeItem(FLAG);
    } catch (err) {}
    if (pending) log('queued celebration found, age ms:', Date.now() - +pending);
    if (pending && Date.now() - +pending < 20000) setTimeout(function () { play({ via: 'after page reload' }); }, 500);

    if (/[?&]diwali_test=1\b/.test(location.search)) setTimeout(function () { play({ force: true }); }, 800);
  }

  log('device:', navigator.userAgent);
  log('loaded. active now:', isActive(), isActive() ? '' : '(' + whyInactive() + ')', '| reduce motion:', !!reduceMotion, '| end date:', cfg.endDate || 'none', '| mobile:', cfg.mobile, '| page:', location.pathname);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  window.DiwaliCrackers = {
    play: function () { lastPlay = 0; play({ force: true }); },
    config: cfg
  };
})();